import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { PostClientRequest } from "services/clientRequests";
import { UpdateClientRequest } from "services/clientRequests";
import { t } from "i18next";

export default function UseUpdateClientRequests() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(({clientRequestStatusId, clientRequestId}: any)=>UpdateClientRequest(clientRequestStatusId, clientRequestId), {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            type: "success",
            message: t("the_request_has_been_updated_successfully"),
          });
        //   queryClient.invalidateQueries("tickets");
          queryClient.invalidateQueries("clientRequests");
        }
      },
    }),
  };
}
